import { Modal, useToast } from '@arnold/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
interface NetworkErrorModalProps {
  isMutation?: boolean;
  onRetry?: () => void;
}

export const NetworkErrorModal = ({ isMutation, onRetry }: NetworkErrorModalProps) => {
  const [isOnLine, setIsOnLine] = useState(navigator.onLine);
  const { t } = useTranslation('networkErrorModal');
  const { addToast } = useToast();

  const declineSavingAndReload = () => {
    if (isOnLine) {
      // saving can be declined only if the user is online
      // we cannot just close the modal and continue
      // because the user did not save the changes
      // and some components might be broken
      // so we need to reload the page
      window.location.reload();
    }
  };

  const submit = () => {
    if (!isOnLine || !isMutation) {
      return;
    }
    addToast(t('changesSaved'));
    onRetry?.();
  };

  useEffect(() => {
    const handleOnline = () => setIsOnLine(true);
    const handleOffline = () => setIsOnLine(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Modal
      show
      onHide={declineSavingAndReload}
      hideAfterSubmit={false}
      onSubmit={submit}
      title={t(isMutation ? (isOnLine ? 'titleSavingOnline' : 'titleSavingOffline') : 'titleLoading')}
      text={t(isMutation ? (isOnLine ? 'textSavingOnline' : 'textSavingOffline') : 'textLoading')}
      buttons={isMutation ? { submit: { title: t('submitSaving'), disabled: !isOnLine } } : undefined}
    />
  );
};
